import { ReportsActions } from './actions'
import { ReportsGetters } from './getters'
import { ReportsMutations } from './mutations'
import { ReportsState } from './state'

export const REPORTS_NAMESPACE = 'reportsModule'

export const Reports = {
  namespaced: true,
  state: ReportsState,
  actions: ReportsActions,
  mutations: ReportsMutations,
  getters: ReportsGetters,
}
